// Models
import { IEmployerStatus } from '@models/ElectronicPayroll';
// Constants
import { EmployerCodes } from '../constants/EmployerCodes';

export const checkEmployerCode = (status: IEmployerStatus): boolean => {
    return status.code === EmployerCodes.AVAILABLE;
};
